

export default function UpdateEditing({ updateEditingValue }) {
    return async ({ key, value }) => {
        updateEditingValue(key, value)
    }
}